<script>
   import { cmp,rnd } from './store.js';
   import { createEventDispatcher } from 'svelte';
   
   rnd.useLocalStorage();
   const dispatch = createEventDispatcher();
</script>

<style>
	button {
	border: none;
	border-radius: 12px;
	color: white;
	padding: 10px;
	text-align: center;
	text-decoration: none;
	display: inline-block;
	font-size: 16px;
	margin: 6px 4px;
	}
	
	.block {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
	}
	
	#footer {
     position: absolute;
     bottom:0;
     width:100%;
	}
	
	.boff {
      background-color: #3880ff;
    }

    .flip {
	  background-color:	#7044ff;
	}
   
</style>

<div id="footer">  
<div class="block">
     <button class="button boff" on:click={() => {if ($rnd > 0) $rnd -= 1; dispatch('CmpUpd')}}>Prev Round</button>
	 <div class="block"><button class="button flip" on:click={() => history.back()}>Leagues</button></div>
     <button class="button boff" on:click={() => {if (($rnd < 1) || ($cmp == 9) && ($rnd < 2)) $rnd += 1; dispatch('CmpUpd')}}>Next Round</button>
</div>
</div>